module.exports = ".map {\n  height: 120px;\n  width: 100%; }\n"